import { createAction, props } from '@ngrx/store';

export const storeSubscriptionData = createAction(
  '[Subscription] Store Subscription Data',
  props<{ ai_tokens: number, credits: number, on_trial: boolean, subscribed: boolean }>()
);

export const retrieveSubscriptionData = createAction(
  '[Subscription] Retrieve Subscription Data'
);

export const loadCredits = createAction(
  '[Subscription] Load Credits'
);

export const loadCreditsSuccess = createAction(
  '[Subscription] Load Credits Success',
  props<{
    current_balance: number;
    last_allocation_date: string;
    next_allocation_date: string;
    subscription_amount: number;
    credits: number; // For backward compatibility (synced with current_balance)
    ai_tokens?: number;
    user?: any;
  }>()
);

export const loadCreditsFailure = createAction(
  '[Subscription] Load Credits Failure',
  props<{ error: any }>()
);

export const clearSubscriptionData = createAction(
  '[Subscription] Clear Subscription Data'
);

export const updateSubscription = createAction(
  '[Auth] Update Subscription',
  props<{ ai_tokens: number, credits: number, on_trial: boolean, subscribed: boolean }>()
);
